import FileUpload, { ICallable } from './FileUpload';
import FileUploadProgress from './FileUploadProgress';

export { FileUpload, FileUploadProgress };
export type { ICallable };

export default FileUpload;
